import React from "react";
import loading from "../assets/loading.svg";

const Spinner = () => (
    <img style={{width: '40%', margin: 'auto'}} src={loading} alt="Loading" />
);

export default Spinner;
